module.exports = __webpack_public_path__ + "static/img/4.49b9c8c4.png";